import { jwtDecode } from "jwt-decode";

/**
 * Selects the current user object from the Redux state.
 */
export const selectUser = (state) => state.session?.user || null;

/**
 * Selects the access token from the Redux state.
 */
export const selectAccessToken = (state) => state.session?.accessToken || null;

export const selectLocale = (state) => state.session.locale;

/**
 * Extracts and decodes the user ID from the JWT access token.
 */
export const selectUserId = (state) => {
  const accessToken = selectAccessToken(state);

  if (!accessToken) return undefined;

  try {
    return jwtDecode(accessToken).userData.id;
  } catch (error) {
    console.error("JWT decoding failed:", error);
    return undefined;
  }
};

export const selectVimeoAccessToken = (state) => {
  const user = state.session?.user;
  if (!user) return undefined;

  return user.vimeo?.accessToken;
};
